y<template>
  <div v-if="visible" class="mention-popup" :class="{'mention-popup--top': placement === 'top'}">
    <!-- DEBUG: visible={{visible}} usersCount={{users.length}} activeIndex={{activeIndex}} keyword={{keyword}} -->
    <div class="mention-popup-header">选择要提及的用户</div>
    <div class="mention-popup-list">
      <div
        v-if="loading"
        class="mention-popup-loading"
      >
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div
        v-else-if="users.length === 0 && keyword"
        class="mention-popup-empty"
      >
        暂无匹配用户
      </div>
      <div
        v-for="(user, index) in users"
        :key="user.id"
        class="mention-popup-item"
        :class="{ active: index === activeIndex }"
        @mousedown.prevent
        @click="handleSelect(user)"
        @mouseenter="handleMouseEnter(index)"
      >
        <span class="mention-avatar">{{ (user.trueName || '?').charAt(0) }}</span>
        <div class="mention-info">
          <span class="mention-realname" v-html="highlight(user.trueName)"></span>
        </div>
      </div>
    </div>
    <div class="mention-popup-footer">
      <kbd>↑↓</kbd> 导航 <kbd>Enter</kbd> 选择 <kbd>Esc</kbd> 关闭
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    keyword: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      placement: 'bottom' // 'top' or 'bottom'
    }
  },
  watch: {
    visible(val) {
      console.log('[MentionPopup] visible changed to:', val, 'users:', this.users.length, 'keyword:', this.keyword)
      if (val) {
        this.calculatePlacement()
      }
    },
    users: {
      handler(val) {
        console.log('[MentionPopup] users changed, count:', val.length, 'visible:', this.visible)
      },
      deep: false
    }
  },
  mounted() {
    console.log('[MentionPopup] mounted, initial visible:', this.visible, 'users:', this.users.length)
  },
  methods: {
    calculatePlacement() {
      this.$nextTick(() => {
        const popup = this.$el
        if (!popup) return
        const wrapper = popup.parentElement
        if (!wrapper) return
        const wrapperRect = wrapper.getBoundingClientRect()
        const popupHeight = 240 // 预估下拉框最大高度
        const spaceTop = wrapperRect.top
        const spaceBottom = window.innerHeight - wrapperRect.bottom

        if (spaceBottom > popupHeight) {
          this.placement = 'bottom'
        } else {
          this.placement = 'top'
        }
      })
    },
    handleSelect(user) {
      this.$emit('select', user)
    },
    handleMouseEnter(index) {
      this.$emit('update:activeIndex', index)
    },
    highlight(text) {
      if (!text) return ''
      if (!this.keyword) return this.escapeHtml(text)
      const re = new RegExp(`(${this.escapeRegExp(this.keyword)})`, 'gi')
      return this.escapeHtml(text).replace(re, '<em>$1</em>')
    },
    escapeHtml(str) {
      return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
    escapeRegExp(str) {
      return str.replace(/[.*+?^${}()[\]\\]/g, '\\$&')
    }
  }
}
</script>

<style scoped>
.mention-popup {
  position: absolute;
  z-index: 99999;
  top: calc(100% + 4px);
  left: 0;
  width: 240px;
  height: 240px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  animation: mentionFadeInBottom 0.15s ease;
  pointer-events: auto;
}

.mention-popup--top {
  top: auto;
  bottom: calc(100% + 4px);
  animation: mentionFadeInTop 0.15s ease;
}

.mention-popup::after {
  content: '';
  position: absolute;
  bottom: -7px;
  left: 16px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-right: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  transform: rotate(45deg);
}

.mention-popup--top::after {
  bottom: auto;
  top: -7px;
  border-right: none;
  border-bottom: none;
  border-left: 1px solid #e4e7ed;
  border-top: 1px solid #e4e7ed;
}

@keyframes mentionFadeInTop {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes mentionFadeInBottom {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

.mention-popup-header {
  padding: 8px 14px;
  font-size: 12px;
  color: #909399;
  border-bottom: 1px solid #f0f0f0;
  background: #fafbfc;
}

.mention-popup-list {
  height: 200px;
  overflow-y: auto;
  padding: 4px 0;
}

.mention-popup-loading {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 13px;
}

.mention-popup-empty {
  text-align: center;
  padding: 20px;
  color: #c0c4cc;
  font-size: 13px;
}

.mention-popup-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.12s;
}

.mention-popup-item:hover,
.mention-popup-item.active {
  background: #ecf5ff;
}

.mention-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.mention-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.mention-realname {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.mention-username {
  font-size: 12px;
  color: #909399;
}

.mention-realname ::v-deep em,
.mention-username ::v-deep em {
  font-style: normal;
  color: #409EFF;
  background: #ecf5ff;
  border-radius: 2px;
  padding: 0 2px;
}

.mention-popup-footer {
  padding: 5px 14px;
  font-size: 11px;
  color: #c0c4cc;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 3px;
}

.mention-popup-footer kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 10px;
  color: #606266;
  padding: 0 4px;
  font-family: inherit;
}
</style>